"use client";

import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import {
  PolicyDetailsAccordionType,
  TravellersAccordionType,
  RenewalContactDetailsAccordionType,
  PolicyExtrasAccordionType,
  MedicalAccordionType,
} from "@/schema/renewal-page/middle-panel.schema";

import MiddlePanelLoaded from "./middle-section-loaded/middle-section-loaded";
import MiddlePanelLoading from "./middle-section-loading/middle-section-loading";

type MiddlePanelType = {
  content: {
    policyDetailsAccordionData: PolicyDetailsAccordionType;
    contactDetailsAccordionData: RenewalContactDetailsAccordionType;
    travellersAccordionData: TravellersAccordionType;
    medicalAccordionData: MedicalAccordionType;
    policyExtrasAccordionData: PolicyExtrasAccordionType;
  };
};

export default function MiddlePanel({ content }: Readonly<MiddlePanelType>) {
  const { isLoading } = useRenewalStateContext();

  return (
    <div>
      {isLoading ? (
        <MiddlePanelLoading />
      ) : (
        <MiddlePanelLoaded content={content} />
      )}
    </div>
  );
}
